import { FC } from "react";
import BtagStatisticsTable from "./BtagTable";
import BtagStatisticsHeader from "./BtagTableHeader";

type BtagTemplateProps = {
  data: any;
  isLoading: boolean;
  filter: { [key: string]: string | string[] };
  setFilter: (val: string) => void;
  setPage: (val: number) => void;
  setPageSize: (val: number) => void;
  currentPage: number;
};

const BtagTemplate: FC<BtagTemplateProps> = ({
  data,
  isLoading,
  filter,
  setFilter,
  setPage,
  setPageSize,
  currentPage,
}) => (
  <div className="btag-container">
    <BtagStatisticsHeader filter={filter} setFilter={setFilter} />
    <BtagStatisticsTable
      data={data}
      isLoading={isLoading}
      setPage={setPage}
      setPageSize={setPageSize}
      currentPage={currentPage}
    />
  </div>
);

export default BtagTemplate;
